"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayFromString = void 0;
const effect_1 = require("effect");
/**
 * Schema that transforms a string representation of an array (e.g., "[100,249]")
 * into an actual array of numbers, or passes through existing arrays.
 * Empty strings return empty arrays. Null/undefined inputs will fail.
 */
exports.ArrayFromString = effect_1.Schema.Union([effect_1.Schema.String, effect_1.Schema.Array(effect_1.Schema.Number)]).pipe(effect_1.Schema.decodeTo(effect_1.Schema.Array(effect_1.Schema.Number), effect_1.SchemaTransformation.transformEffect({
    decode: (input, options) => {
        // Pass through existing arrays
        if (Array.isArray(input)) {
            return effect_1.Effect.succeed(input);
        }
        // Parse string representations
        if (typeof input === 'string') {
            try {
                // Handle empty string - return empty array
                if (input.trim() === '') {
                    return effect_1.Effect.succeed([]);
                }
                // Parse JSON string (e.g., "[100,249]")
                const parsed = JSON.parse(input);
                // Validate that it's an array
                if (!Array.isArray(parsed)) {
                    return effect_1.Effect.fail(new effect_1.SchemaIssue.InvalidValue({ message: 'String does not represent an array' }, input, options));
                }
                // Validate that all elements are numbers
                for (let i = 0; i < parsed.length; i++) {
                    if (typeof parsed[i] !== 'number' || isNaN(parsed[i])) {
                        return effect_1.Effect.fail(new effect_1.SchemaIssue.InvalidValue({ message: `Array element at index ${i} is not a valid number` }, input, options));
                    }
                }
                return effect_1.Effect.succeed(parsed);
            }
            catch (error) {
                return effect_1.Effect.fail(new effect_1.SchemaIssue.InvalidValue({ message: 'Invalid JSON array string' }, input, options));
            }
        }
        return effect_1.Effect.fail(new effect_1.SchemaIssue.InvalidValue({ message: 'Expected string or array' }, input, options));
    },
    encode: (input) => {
        // Convert arrays back to JSON string format
        return effect_1.Effect.succeed(JSON.stringify(input));
    },
})));
//# sourceMappingURL=array-from-string.js.map